import React from "react";

const DepartmentAdminHelpInstructions = () => {
  return (
    <div className="card-wrap" id="studentresource">
      <div className="title">
        <h2>Help</h2>
      </div>
      <div className="row help-wrap">
        <div className="col-lg-3 col-md-3">
          <div className="sidebar" id="sidebar">
            <h2>Table of Contents</h2>
            <a href="#introduction">Introduction</a>
            <a href="#login">Login</a>
            <a href="#configuration">1. Configuration</a>
            <a href="#visibility-priority">2. Visibility & Priority Settings</a>
            <a href="#feedback">3. Feedback</a>
            <a href="#settings">4. Settings</a>
            <a href="#navbar">5. Navigation Bar</a>
          </div>
        </div>
        <div className="col-lg-9 col-md-3">
          <div className="content">
            <div id="introduction" className="section">
              <h2>Introduction</h2>
              <p>
                This user manual serves as a comprehensive guide to help you
                navigate the Budu Portal with ease. It covers key features,
                step-by-step instructions, and tips to make the most of the
                portal’s capabilities.
              </p>
            </div>

            <div id="login" className="section">
              <h2>Login</h2>
              <p>
                The login page allows Department Admin user to securely sign in.
                Follow these steps:
              </p>
              <ol>
                <li>
                  Click the URL:{" "}
                  <a
                    href="https://demo.ui.buduportal.com/login"
                    target="_blank"
                  >
                    https://demo.ui.buduportal.com/login
                  </a>
                </li>
                <li>Enter username and password in the fields provided.</li>
                <li>Click the 'Login' button to access the main dashboard.</li>
              </ol>
              <img src="assets/images/help/login.png" alt="Login" />
            </div>

            <div id="configuration" className="section">
              <h2>1. Configuration</h2>
              <h3>1.1 Notifications</h3>
              <h3>1.1.1 Notifications List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Notifications. Each
                Notifications entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the notification’s
                  information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the
                  notification from the list (not permanent deletion).
                </li>
                <img
                  src="assets/images/help/deptNotification_list.png"
                  alt="Notification Index"
                />
              </ul>
              <h3>1.1.2 Add a New Notification</h3>
              <ol>
                <li>Navigate to the Configuration Page &gt; Notifications</li>
                <li>
                  {" "}
                  Click on the “Add New” Notification. A popup titled "Add New
                  Notification" will appear.
                </li>
                <li>Notification type: Select notification type</li>
                <li>
                  User type: By default the user type "Staff" will be selected.
                </li>
                <li> Title: Add notification title</li>
                <li>Image:Add image using choose file option</li>
                <li>Notification message: Add notification message</li>
                <li>
                  Start date and end date: Select the date. Based on these
                  dates, the notification will be visible to users.
                </li>
                <li>
                  Click on the “Save” Button: The new notification will be
                  created and listed on the index page.
                </li>
                <img
                  src="assets/images/help/add_deptNotification.png"
                  alt="Add Notification"
                />
              </ol>

              <h3>1.2 Training </h3>
              <h3>1.2.1 Training List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Training. Each
                Training entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the Training’s
                  information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the training.
                  from the list (not permanent deletion)
                </li>
                <img
                  src="assets/images/help/training_list.png"
                  alt="Training Index"
                />
              </ul>
              <h3>1.2.2 Add a New Training</h3>
              <ol>
                <li>
                  {" "}
                  Click on the “Add New” Training. A popup titled "Add New
                  Training" will appear.
                </li>
                <li>
                  Training Category: Select training category on dropdown
                  (Training data fetch from API)
                </li>
                <li>Icon: Add icon using choose file option</li>
                <li>Training Name: Add training name</li>
                <li>Training description: Add training description</li>
                <li>Choose training mandatory Yes/No</li>
                <li>
                  Mode of training: Choose Attend in person/online options
                </li>
                <li>
                  Training Start Date: Select the date. The "Attend" button will
                  be active from this date
                </li>
                <li>
                  End Date: Select the end date. The training will be removed
                  after this date.
                </li>
                <li>Link to attend the training: Add training link</li>
                <li>Registration Link: Add training registration link</li>
                <li>
                  College name, department name: These fields will be prefilled
                  based on the department admin's assigned college and
                  department.
                </li>
                <li>
                  Page block: Configured pages of corresponding users are listed
                </li>
                <li>
                  Location: If "No" is selected for online mode, the location
                  field will be enabled to enter location details.
                </li>
                <li>
                  Click on the “Save” Button: The new Training will be created
                  and listed on the index page.
                </li>
                <img
                  src="assets/images/help/add_training.png"
                  alt="Add Training"
                />
              </ol>

              <h3>1.3 Report </h3>
              <h3>1.3.1 Report List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Report. Each Report
                entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the Report’s information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the Report.
                  from the list (not permanent deletion)
                </li>
                <img
                  src="assets/images/help/report_list.png"
                  alt="Report Index"
                />
              </ul>
              <h3>1.3.2 Add a New Report</h3>
              <ol>
                <li>Navigation to Report page</li>
                <li>
                  {" "}
                  Click on the “Add New” Report. A popup titled "Add New Report"
                  will appear.
                </li>
                <li>User type: Choose user type as staff or faculty</li>
                <li>
                  Report Name: Choose report name from dropdown (Report details
                  fetch from API)
                </li>
                <li>Choose file: Upload icon by choose file option</li>
                <li>Description: Add description</li>
                <li>
                  URL: Enter the link to which the user should be redirected.
                </li>
                <li>Report frequency: Select report frequency</li>
                <li>
                  Page block:Configured pages of corresponding users are listed
                </li>
                <li>
                  College name, department name: These fields will be prefilled
                  based on the department admin's assigned college and
                  department.
                </li>
                <li>
                  Click on the “Save” Button: The new Report will be created and
                  listed on the index page.
                </li>
                <img src="assets/images/help/add_report.png" alt="Add Report" />
              </ol>

              <h3>1.4 Department Resources </h3>
              <h3>1.4.1 Department Resources List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Department
                Resources. Each Department Resources entry includes the
                following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the Department
                  Resources’s information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the
                  Department Resources. from the list (not permanent deletion)
                </li>
                <img
                  src="assets/images/help/deptResource_list.png"
                  alt="Department Resources Index"
                />
              </ul>
              <h3>1.4.2 Add a New Department Resources</h3>
              <ol>
                <li>Navigation to Department Resources</li>
                <li>
                  {" "}
                  Click on the “Add New” Department Resource. A popup titled
                  "Add New Department Resources" will appear.
                </li>
                <li>Resources Name: Add resource name</li>
                <li>Description: Add description</li>
                <li>Choose Icon: Upload icon by choose file option</li>
                <li>
                  URL: Enter the link to which the user should be redirected.
                </li>
                <li>
                  Page block:Configured pages of corresponding users are listed
                </li>
                <li>
                  College name, department name: These fields will be prefilled
                  based on the department admin's assigned college and
                  department.
                </li>
                <li>
                  Click on the “Save” Button: The new Department Resource will
                  be created and listed on the index page
                </li>
                <img
                  src="assets/images/help/add_deptResource.png"
                  alt="Add Department Resource"
                />
              </ol>

              <h3>1.5 Training Help </h3>
              <h3>1.5.1 Training Help List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Training Help. Each
                Training Help entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the Training Help’s
                  information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the Training
                  Helps. from the list (not permanent deletion)
                </li>
                <img
                  src="assets/images/help/trainingHelp_list.png"
                  alt="Training Help Index"
                />
              </ul>
              <h3>1.5.2 Add a New Training Help</h3>
              <ol>
                <li>Navigate to Training Help</li>
                <li>
                  {" "}
                  Click on the “Add New” Training Help. A popup titled "Add New
                  Training Help" will appear.
                </li>
                <li>Name: Add training name</li>
                <li>Image: Upload icon by choose file option</li>
                <li>Video link: Add training video link</li>
                <li>
                  Page block:Configured pages of corresponding users are listed
                </li>
                <li>
                  Department name, college name: These fields will be prefilled
                  based on the department admin's assigned college and
                  department.
                </li>
                <li>
                  Click on the “Save” Button: The new Training Help will be
                  created and listed on the index page
                </li>
                <img
                  src="assets/images/help/add_trainingHelp.png"
                  alt="Add Training Help"
                />
              </ol>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student/Freshman</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Button</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Widget</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>App</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Notification</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Technology Resources</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Email Configuration</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Training</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Report</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Department Resources</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Training Help</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="visibility-priority" className="section">
              <h2>2. Visibility & Priority Settings</h2>
              <p>
                Users have the ability to set the visibility and priority of
                configured dashboard items based on different personas: Staff,
                Student, and Faculty.
              </p>
              <h3>2.1 Staff</h3>
              <ul>
                <li>Navigate to “Staff”</li>
                <li>
                  Change Visibility: Uncheck the radio button to hide any item.
                </li>
                <li>
                  Change Order: Drag and drop items to rearrange the display
                  order
                </li>
              </ul>
              <h3>2.2 Faculty</h3>
              <ul>
                <li>Navigate to “Faculty”</li>
                <li>
                  Change Visibility: Uncheck the radio button to hide any item.
                </li>
                <li>
                  Change Order: Drag and drop items to rearrange the display
                  order
                </li>
              </ul>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student/Freshman</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Staff Visibility and Priority settings</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Faculty Visibility and Priority settings</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                </tr>
                <tr>
                  <td>Student visibility and Priority Settings</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="feedback" className="section">
              <h2>3. Feedback</h2>
              <p>
                The Feedback module allows users to send feedback messages and
                rate their experience with the system. It includes options to
                submit comments, suggestions, and star ratings.
              </p>
              <h3>3.1 Sending Feedback</h3>
              <ul>
                <li>
                  Click on the Feedback Menu and it will be redirected to the
                  Feedback Page
                </li>
                <img src="assets/images/help/deptAdmin_feedback.png" alt="Feedback" />
                <li>Subject: Enter Subject</li>
                <li>
                  Message: Type your message or comments in the Message field.
                </li>
                <li>Send: Click the Send button to submit your feedback.</li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback and
                  return to the previous page.
                </li>
              </ul>
              <h3>3.2 Rate Us</h3>
              <ul>
                <li>
                  Rate Us Button : Click on rate us button , a rating popup will
                  appear.
                </li>
                <img src="assets/images/help/rating.png" alt="Rate Us" />
                <li>Select star rating to reflect your experience.</li>
                <li>
                  Provide any additional comments or suggestions in the input
                  field.
                </li>
                <li>
                  Submit : Click the Submit button to record your rating and
                  feedback.
                </li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback
                </li>
              </ul>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Feedback</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
                <tr>
                  <td>Rate Us</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
              </table>
            </div>

            <div id="settings" className="section">
              <h2>4. Settings</h2>
              <h3>4.1 Edit Profile</h3>
              <p>
                The Edit Profile option allows users to update their display
                name and profile picture.
              </p>
              <ul>
                <li>Navigate to the Settings Page.</li>
                <li>
                  Edit Profile Button : By clicking a popup will appear for
                  editing profile.
                </li>
                <img
                  src="assets/images/help/editProfile.png"
                  alt="Edit Profile"
                />
                <li>
                  Edit Icon: Click on the current profile image to upload a new
                  one.
                </li>
                <li>
                  Username : Edit the Username field to update your display name
                  on the portal.
                </li>
                <li>Save Changes: Click to Saves updated profile details.</li>
                <li>Close : Closes the popup without saving any changes.</li>
              </ul>
            </div>

            <div id="navbar" className="section">
              <h2>5. Navigation Bar</h2>
              <ul>
                <li>
                  Email: Clicking on the Email Icon will redirect to the Outlook
                  Mail Inbox.
                </li>
                <li>
                  Profile Icon: A list of departments will be displayed if
                  multiple departments are assigned to the user. The user can
                  switch between departments if needed. Once the Logout button
                  is clicked, you will be logged out and redirected to the login
                  page.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentAdminHelpInstructions;
